export default function ProductBuyer({ product }) {
  const buyer = product.idealBuyer || {};
  return (
    <section className="product-block">
      <div className="product-block__head">/ Ideal buyer</div>
      <h4 className="product-block__title">Who this is for</h4>
      <div className="product-buyer">
        <p>{buyer.summary}</p>
        <ul>
          {(buyer.bullets || []).map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
